import { Logger, LoggerFactory } from './../logger.service';
import { TriggerbeeApi } from './triggerbee-api.enum';
import { Inject, Injectable } from '@angular/core';

import { Environment, ENVIRONMENT_DI } from './../../environment/environment';

export { TriggerbeeApi } from './triggerbee-api.enum';

@Injectable()
export class TriggerbeeUrlBuilder {
  private readonly logger: Logger;

  constructor(
    loggerFactory: LoggerFactory,
    @Inject(ENVIRONMENT_DI) private readonly environment: Environment,
  ) {
    this.logger = loggerFactory.get('TriggerbeeUrlBuilder');
  }

  buildUrl(api: TriggerbeeApi, resource = '', parameters: any = null): string {
    const baseUrl = this.getBaseUrl(api);
    if (!baseUrl) {
      this.logger.error('Could not found base url for api : ' + api.toString());
      return '';
    }
    return this.addResourceAndParameters(baseUrl, resource, parameters);
  }

  buildSelfUrl(resource = '', parameters: any = null): string {
    return this.addResourceAndParameters(this.environment.selfBaseUrl, resource, parameters);
  }

  private addResourceAndParameters(baseUrl: string, resource = '', parameters: any = null): string {
    if (!baseUrl) {
      this.logger.error('Could not found base url');
      return '';
    }

    // Add slash at the end of base
    if (!baseUrl.endsWith('/')) {
      baseUrl = baseUrl + '/';
    }

    // Fix resource string
    if (resource && resource.startsWith('/')) {
      resource = resource.substring(1, resource.length);
    }

    // Build query string
    let queryString = '';
    if (parameters) {
      queryString = this.toQueryString(parameters);
    }

    // Build url
    const url = baseUrl + resource + queryString;
    return url;
  }

  private toQueryString(object: any) {
    if (!object) {
      return '';
    }
    return (
      '?' +
      Object.keys(object)
        .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(object[key]))
        .join('&')
    );
  }

  private getBaseUrl(api: TriggerbeeApi): string {
    switch (api) {
      case TriggerbeeApi.Gateway:
        return this.environment.apiBaseUrls.gateway;
      default:
        throw new Error('Unknown triggerbee api: ' + api);
    }
  }
}
